import { render, staticRenderFns } from "./CourseMessages.vue?vue&type=template&id=54f42fc1&scoped=true"
import script from "./CourseMessages.vue?vue&type=script&lang=js"
export * from "./CourseMessages.vue?vue&type=script&lang=js"
import style0 from "./CourseMessages.vue?vue&type=style&index=0&id=54f42fc1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f42fc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f42fc1')) {
      api.createRecord('54f42fc1', component.options)
    } else {
      api.reload('54f42fc1', component.options)
    }
    module.hot.accept("./CourseMessages.vue?vue&type=template&id=54f42fc1&scoped=true", function () {
      api.rerender('54f42fc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CourseMessages.vue"
export default component.exports